const MOUNT_RADIUS = 2;

export function slideMediaMounted({
    mountGallery,
    index,
    slideIndex,
    scrollTarget,
}: {
    mountGallery: boolean;
    index: number;
    slideIndex: number;
    scrollTarget: number | null;
}) {
    if (!mountGallery) return slideIndex === index;
    if (Math.abs(slideIndex - index) <= MOUNT_RADIUS) return true;
    return (
        scrollTarget !== null &&
        Math.abs(slideIndex - scrollTarget) <= MOUNT_RADIUS
    );
}
